import { render, staticRenderFns } from "./editSellerWordsInfo.vue?vue&type=template&id=45a5f154&scoped=true"
import script from "./editSellerWordsInfo.vue?vue&type=script&lang=js"
export * from "./editSellerWordsInfo.vue?vue&type=script&lang=js"
import style0 from "./editSellerWordsInfo.vue?vue&type=style&index=0&id=45a5f154&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a5f154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a5f154')) {
      api.createRecord('45a5f154', component.options)
    } else {
      api.reload('45a5f154', component.options)
    }
    module.hot.accept("./editSellerWordsInfo.vue?vue&type=template&id=45a5f154&scoped=true", function () {
      api.rerender('45a5f154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/components/editSellerWordsInfo.vue"
export default component.exports